import { FlexColumn } from '@elementary/common-ui/components';
import RuleAccordion, { RuleAccordionProps } from './RuleAccordion';
import RuleEmptyState from './RuleEmptyState';

type Props = {
  data: RuleAccordionProps[];
  isLoading: boolean;
  emptyStateTitle: string;
  emptyStateDescription: string;
};

const RuleList = ({
  data,
  isLoading,
  emptyStateTitle,
  emptyStateDescription,
}: Props) =>
  !isLoading && data.length === 0 ? (
    <RuleEmptyState
      title={emptyStateTitle}
      description={emptyStateDescription}
    />
  ) : (
    <FlexColumn sx={{ gap: 2 }}>
      {data.map((item) => (
        <RuleAccordion key={item.id} {...item} />
      ))}
    </FlexColumn>
  );

export default RuleList;
